// JavaScript Document

// ページ内リンク
$('a[href^="#"]').click(function(){
  let speed = 200;
  let href= $(this).attr("href");
  let target = $(href == "#" || href == "" ? 'html' : href);
  let header = $('.header__inner').height();
  let position = target.offset().top - header - 30;
  $('html, body').animate({scrollTop:position}, speed, 'swing');
  return false;
});

// アコーディオン
$(function(){
	$('.aco-ttl').on('click', function(){
    $('.aco-ttl').removeClass('is-open');
    $('.aco-detail').slideUp('fast');
		$(this).toggleClass('is-open');
		$(this).next().stop().slideToggle('fast');
	});
});
$('.list-pagelink .link').click(function(){
  let href= $(this).attr('href');
	$(href + '.aco-ttl').addClass('is-open');
	$(href + '.aco-ttl').next().stop().slideDown('fast');
  return false;
});

// 外部リンクを別窓で開く
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
